module.exports = __webpack_public_path__ + "../front/img/3683skuffer+hylder.860b15af.svg";